// SINGLE SOURCE OF TRUTH for Make/Model tag aliases and related helpers, shared by every
// vehicle-selection surface on the site: the homepage selector (ymm-filter.js), collection
// page pills, and search-results page pills (both in vehicle-pills.js). Load this script
// BEFORE any of those. Previously each of those files kept its own independent copy of
// MAKE_TAGS/MODEL_TAGS, which is exactly the kind of drift that causes one surface to resolve
// a tag differently than another for the same make/model -- this file exists so there is only
// ever one place to update.
window.ESVehicleTags = (function(){
  const MAKE_TAGS = {
    "Volkswagen": ["vw","volkswagen"], "Audi": ["audi"], "BMW": ["bmw"],
    "Mercedes": ["mercedes","mb","mercedes-benz"], "Porsche": ["porsche"],
    "Seat": ["seat"], "Skoda": ["skoda"], "Mini": ["mini"]
  };
  const MODEL_TAGS = {
    "Atlas":["atlas"], "Touareg":["touareg"],
    "Golf R": ["r","golf-r","golfr"], "Golf GTI": ["gti"], "GTE":["gte"], "GTD":["gtd"], "Golf GTE":["gte"], "Golf GTD":["gtd"], "Golf": ["golf"],
    "Polo":["polo"], "Polo GTI": ["polo-gti","polo"], "Scirocco":["scirocco"], "Scirocco R":["scirocco-r","scirocco"],
    "Jetta":["jetta"], "Passat":["passat"], "Arteon":["arteon"], "Tiguan":["tiguan"], "T-Roc R":["t-roc-r","troc-r"],
    "A3":["a3"], "S3":["s3"], "RS3":["rs3"], "A4":["a4"], "S4":["s4"], "RS4":["rs4"], "A5":["a5"], "S5":["s5"], "RS5":["rs5"],
    "TT":["tt"], "TTS":["tts"], "TT RS":["tt-rs","ttrs"], "Q3":["q3"], "Q5":["q5"], "SQ5":["sq5"], "RSQ3":["rsq3"], "Q7":["q7"], "Q8":["q8"], "RSQ8":["rsq8"],
    "A6":["a6"], "S6":["s6"], "RS6":["rs6"], "A7":["a7"], "S7":["s7"], "RS7":["rs7"],
    "1 Series":["1-series","1series"], "2 Series":["2-series","2series"], "M2":["m2"],
    "3 Series":["3-series","3series"], "M3":["m3"], "4 Series":["4-series"], "M4":["m4"], "5 Series":["5-series"], "M5":["m5"],
    "Macan":["macan"], "Cayenne":["cayenne"], "Panamera":["panamera"],
    "911":["911","992","991","997"], "Cayman":["cayman"], "Boxster":["boxster"]
  };

  function handleize(str){
    return (str||'').toString().trim().toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g,'')
      .replace(/&/g,'-and-').replace(/[^a-z0-9]+/g,'-')
      .replace(/-+/g,'-').replace(/^-|-$/g,'');
  }
  function aliasesFor(map, key){ return (map[key] && map[key].length) ? map[key] : [handleize(key)]; }
  function pickAlias(map, key){ return aliasesFor(map, key)[0]; } // alias name kept for ymm-filter.js compatibility
  function primaryTag(map, key){ return aliasesFor(map, key)[0]; } // alias name kept for vehicle-pills.js compatibility

  // Many real products intentionally use the bare/unqualified chassis tag even when the
  // selected generation is technically a sub-variant of it -- per EuroSpeed's own tagging
  // convention, a part that works across the whole generation regardless of facelift/model-year
  // is tagged with the bare parent code only, not force-split. Two different naming schemes
  // both need stripping down to that bare parent code:
  //  - BMW/Audi word-suffix style: "8v facelift" / "8v pre-facelift" / "e46 lci" -> "8v" / "e46"
  //  - VW/Audi decimal sub-generation style: "mk7.5" -> "mk7", "b8.5" -> "b8", "c7.5" -> "c7"
  // Missing the second form was a real bug: MK7.5/MK8.5/B8.5/B9.5/C7.5 pills either vanished
  // entirely (no product carries the exact qualified tag) or silently collapsed all the way to
  // "All Generations" instead of falling back to the real MK7/MK8/B8/B9/C7 products that
  // actually fit them.
  function baseChassisTag(t){
    return (t||'')
      .replace(/\s+(pre-facelift|facelift|lci)$/i, '')
      .replace(/\.5$/i, '')
      .trim();
  }

  // Make dropdown order, per Jeff: the core German five, then exotics, then other European, then
  // Japanese/Korean, American last. Makes not listed here (new ones the worker starts returning)
  // sit just ahead of the American block; ties keep the worker's own order (stable sort).
  const MAKE_ORDER = [
    "Volkswagen","VW","Audi","BMW","Mercedes","Mercedes-Benz","Porsche",
    "Lamborghini","Ferrari","McLaren","Bentley","Aston Martin","Rolls-Royce","Maserati","Bugatti",
    "Mini","Seat","Cupra","Skoda","Land Rover","Range Rover","Jaguar","Alfa Romeo","Volvo","Lotus","Fiat","Abarth",
    "Toyota","Lexus","Nissan","Infiniti","Honda","Acura","Subaru","Mitsubishi","Mazda","Hyundai","Kia","Genesis"
  ];
  const AMERICAN_MAKES = ["Ford","Chevrolet","Chevy","Dodge","Chrysler","Jeep","Ram","GMC","Cadillac","Buick","Lincoln","Tesla"];
  function makeRank(make){
    const k = (make||'').toString().trim().toLowerCase();
    const i = MAKE_ORDER.findIndex(m => m.toLowerCase() === k);
    if (i >= 0) return i;
    const a = AMERICAN_MAKES.findIndex(m => m.toLowerCase() === k);
    return a >= 0 ? MAKE_ORDER.length + 1 + a : MAKE_ORDER.length;
  }
  function sortMakes(makes){
    return (makes||[]).map((m, i) => [m, i])
      .sort((x, y) => (makeRank(x[0]) - makeRank(y[0])) || (x[1] - y[1]))
      .map(x => x[0]);
  }

  return { MAKE_TAGS, MODEL_TAGS, handleize, aliasesFor, pickAlias, primaryTag, baseChassisTag, MAKE_ORDER, sortMakes };
})();
